import { render, staticRenderFns } from "./DamageAssessorCaseAccidentDataForm.vue?vue&type=template&id=62dea6b6&scoped=true"
import script from "./DamageAssessorCaseAccidentDataForm.vue?vue&type=script&lang=js"
export * from "./DamageAssessorCaseAccidentDataForm.vue?vue&type=script&lang=js"
import style0 from "./DamageAssessorCaseAccidentDataForm.vue?vue&type=style&index=0&id=62dea6b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dea6b6",
  null
  
)

export default component.exports